<template>
  <div class="primary" style="height: 100%">
    <div>
      <v-img
        :src="require('@/assets/dotted_bck.png')"
        style="position: absolute; max-width: 50vw"
      ></v-img>
      <v-img
        :src="require('@/assets/shapes/01.png')"
        style="position: absolute; max-width: 30vw; right: 0; bottom: 0"
      ></v-img>
      <v-img
        :src="require('@/assets/shapes/02.png')"
        style="position: absolute; max-width: 10vw; right: 20%; bottom: 15%"
      ></v-img>
      <v-img
        :src="require('@/assets/shapes/03.png')"
        style="position: absolute; max-width: 30vw; top: 40%; left: 0"
      ></v-img>
      <v-img
        :src="require('@/assets/shapes/06.png')"
        style="position: absolute; max-width: 70vw; bottom: 0px; left: 0"
      ></v-img>
    </div>
    <div class="d-none d-sm-flex">
      <div
        style="
          margin-top: calc(20vh - 80px);
          margin-left: calc(50% - 372px);
          position: absolute;
          z-index: 1;
          width: 744px;
        "
      >
        <div class="circle d-flex justify-center">
          <img
            :src="require('@/assets/icon.png')"
            style="margin-top: 40px; max-width: 120px; max-height: 120px; height: auto; width: auto"
          />
        </div>
      </div>
    </div>
    <div v-if="!company && !isNewUser">
      <div class="mx-auto" style="width: 100px; height: 100; margin-top: 40vh">
        <v-img contain :src="require('@/assets/loop.gif')"></v-img>
      </div>
    </div>
    <div
      v-else
      :style="$vuetify.breakpoint.xsOnly ? 'padding:80px 20px 0px 20px;' : 'padding-top: 20vh'"
    >
      <v-card
        max-width="600"
        class="mx-auto px-4 pb-4"
        :style="`${
          $vuetify.breakpoint.xsOnly ? 'padding-top: 20px' : 'margin-top: 40px; padding-top: 80px'
        }`"
      >
        <v-card-title class="text-h3 primary--text">Welcome to Trip Loop</v-card-title>
        <v-card-text>
          <div class="text-h6">
            As welcoming gift you will be credited $50 when you create the account so you can try
            Trip Loop with your travelers!
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <NewCompanyDialog />
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import NewCompanyDialog from "@/components/Company/NewCompany/NewCompanyDialog";

export default {
  components: { NewCompanyDialog },
  data() {
    return {
      isNewUser: false,
    };
  },
  computed: {
    company() {
      return this.$store.state.obtainedCompanies;
    },
    trips() {
      return this.$store.state.userTrips;
    },
  },
  watch: {
    company(newVal) {
      const companies = Object.keys(this.$store.state.companies);
      if (newVal && companies.length > 0) {
        this.$router.push({ name: "Trips" });
      } else if (newVal) {
        this.isNewUser = true;
      }
    },
    trips(newVal) {
      if (newVal.length > 0) {
        this.$router.push({ name: "Trips" });
      }
    },
  },
};
</script>

<style scoped>
.circle {
  width: 200px;
  height: 200px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
